import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { CaptorRequestFormatter } from "../CaptorRequestFormatter";
export function createCaptorConnection() {
    return createRESTConn({
        name: ConnectionNames.captor,
        handlers: {
            requestFormatter: CaptorRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateCaptorConnection.js.map